import styles from './CopyToast.module.css';

export function CopyToast({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div role="status" className={styles.toast}>
      {message}
    </div>
  );
}
